export const movies = [
  {
    id: 'movie-001',
    title: '春日来信',
    titleEn: 'Letters of Spring',
    category: 'aiqing',
    year: 2025,
    rating: 8.7,
    director: '林子涵',
    actors: ['周雨彤', '张新成', '陈都灵'],
    duration: '118分钟',
    description: '一封封手写的信件，串联起两个年轻人在春日里的相遇与相知。在快节奏的都市生活中，他们用最传统的方式，书写着最纯粹的爱情故事。影片以细腻的镜头语言描绘了爱情萌芽时的美好与悸动，令人回味无穷。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20movie%20poster%20featuring%20a%20young%20couple%20under%20cherry%20blossom%20trees%20in%20spring%2C%20warm%20peach%20and%20cream%20color%20palette%2C%20soft%20cinematic%20lighting%2C%20dreamy%20atmosphere%2C%20elegant%20Chinese%20film%20poster%20design%20with%20artistic%20typography%20and%20minimalist%20composition%2C%20delicate%20petals%20falling%2C%20tender%20emotional%20mood&width=600&height=850&seq=mitao-poster-001&orientation=portrait',
    featured: true,
    releaseDate: '2025-03-15',
  },
  {
    id: 'movie-002',
    title: '笑林外传',
    titleEn: 'Tales of Laughter',
    category: 'xiju',
    year: 2024,
    rating: 8.2,
    director: '马天宇',
    actors: ['沈腾', '马丽', '艾伦'],
    duration: '105分钟',
    description: '一个普通小镇因为一场意外变成欢乐海洋的故事。当三个性格迥异的好友阴差阳错卷入一场荒诞冒险，一连串令人捧腹的事件接踵而至。全片笑点密集，温情满满，是近年来不可多得的喜剧佳作。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20comedy%20movie%20poster%20with%20three%20friends%20laughing%20together%20in%20a%20small%20colorful%20town%2C%20warm%20and%20bright%20amber%20tones%2C%20playful%20atmosphere%2C%20Chinese%20film%20poster%20design%20with%20bold%20typography%2C%20festive%20decorations%2C%20joyful%20vibe%2C%20clean%20minimalist%20background&width=600&height=850&seq=mitao-poster-002&orientation=portrait',
    featured: true,
    releaseDate: '2024-12-20',
  },
  {
    id: 'movie-003',
    title: '暗夜追踪',
    titleEn: 'Night Pursuit',
    category: 'dongzuo',
    year: 2025,
    rating: 8.5,
    director: '成龙',
    actors: ['吴京', '张译', '黄景瑜'],
    duration: '132分钟',
    description: '一名退役特种兵在一座陌生城市卷入国际犯罪集团的惊天阴谋。面对层层危机，他凭借过人的智慧和身手，在暗夜中展开了一场惊心动魄的追踪。高燃打斗场面与紧张刺激的剧情节奏，让观众全程屏息。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20intense%20Chinese%20action%20movie%20poster%20featuring%20a%20soldier%20silhouette%20against%20city%20skyline%20at%20night%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20shadow%20contrast%2C%20cinematic%20style%2C%20Chinese%20action%20film%20poster%20design%2C%20explosive%20energy%2C%20clean%20minimal%20composition&width=600&height=850&seq=mitao-poster-003&orientation=portrait',
    featured: true,
    releaseDate: '2025-05-01',
  },
  {
    id: 'movie-004',
    title: '迷雾剧场',
    titleEn: 'Theatre of Mist',
    category: 'xuanyi',
    year: 2024,
    rating: 8.9,
    director: '忻钰坤',
    actors: ['段奕宏', '谭卓', '王传君'],
    duration: '125分钟',
    description: '一座偏僻小镇发生连环失踪案，刑警队长深入调查后发现，每个失踪者都与十年前的一桩旧案有着千丝万缕的联系。迷雾重重中，真相如同拼图般慢慢展开，而最终的答案令人不寒而栗。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20thriller%20movie%20poster%20with%20foggy%20small%20town%20street%20and%20a%20detective%20figure%2C%20moody%20atmosphere%2C%20cool%20grey%20tones%20with%20warm%20highlight%20accents%2C%20Chinese%20suspense%20film%20poster%20design%2C%20minimalist%20composition%2C%20eerie%20yet%20elegant%2C%20soft%20diffused%20lighting&width=600&height=850&seq=mitao-poster-004&orientation=portrait',
    featured: true,
    releaseDate: '2024-09-30',
  },
  {
    id: 'movie-005',
    title: '星际迷途',
    titleEn: 'Lost in Stars',
    category: 'kehuan',
    year: 2025,
    rating: 8.4,
    director: '郭帆',
    actors: ['刘德华', '吴彦祖', '赵今麦'],
    duration: '148分钟',
    description: '在不远的未来，人类首次尝试星际移民计划。一支由精英科学家和宇航员组成的探险队前往遥远星系，却遭遇前所未有的宇宙危机。壮丽的太空景象与深遂的哲学思考交织，呈现了一场震撼心灵的科幻史诗。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20grand%20Chinese%20sci-fi%20movie%20poster%20showing%20a%20spaceship%20approaching%20a%20distant%20colorful%20nebula%2C%20stunning%20cosmic%20visuals%2C%20warm%20golden%20and%20deep%20space%20contrast%2C%20Chinese%20science%20fiction%20film%20poster%20design%2C%20epic%20scale%2C%20clean%20minimalist%20composition%2C%20majestic%20planetary%20rings&width=600&height=850&seq=mitao-poster-005&orientation=portrait',
    featured: false,
    releaseDate: '2025-07-18',
  },
  {
    id: 'movie-006',
    title: '山海幻境',
    titleEn: 'Mountain Sea Fantasy',
    category: 'donghua',
    year: 2024,
    rating: 9.0,
    director: '饺子',
    actors: ['杨天翔', '赵路', '季冠霖'],
    duration: '110分钟',
    description: '取材自中国古代神话《山海经》，讲述少年踏上寻找失落神器的奇幻冒险旅程。精美的中国风画面与扣人心弦的故事情节相得益彰，每一帧都如同一幅精美的国画，为观众呈现一场视觉与心灵的双重盛宴。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20animation%20movie%20poster%20inspired%20by%20ancient%20Chinese%20mythology%2C%20featuring%20a%20young%20hero%20in%20traditional%20clothing%20among%20floating%20mountains%20and%20magical%20creatures%2C%20warm%20golden%20and%20jade%20green%20color%20scheme%2C%20Chinese%20ink%20painting%20style%2C%20ethereal%20atmosphere%2C%20elegant%20composition&width=600&height=850&seq=mitao-poster-006&orientation=portrait',
    featured: true,
    releaseDate: '2024-08-08',
  },
  {
    id: 'movie-007',
    title: '深夜来访',
    titleEn: 'The Late Visit',
    category: 'kongbu',
    year: 2025,
    rating: 7.8,
    director: '温子仁',
    actors: ['彭于晏', '周迅', '朱一龙'],
    duration: '98分钟',
    description: '一对年轻夫妇搬入郊区的老宅后，每到深夜都会听到神秘的敲门声。随着调查深入，他们发现这栋房子隐藏着一个跨越三十年的恐怖秘密。紧张的氛围营造与精巧的叙事结构，让这部恐怖片成为年度话题之作。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20haunting%20Chinese%20horror%20movie%20poster%20showing%20an%20old%20wooden%20door%20slightly%20open%20in%20a%20dark%20corridor%2C%20dim%20warm%20light%20seeping%20through%2C%20eerie%20atmosphere%2C%20Chinese%20horror%20film%20poster%20design%2C%20minimalist%20composition%2C%20subtle%20shadows%2C%20elegant%20yet%20unnerving&width=600&height=850&seq=mitao-poster-007&orientation=portrait',
    featured: false,
    releaseDate: '2025-10-31',
  },
  {
    id: 'movie-008',
    title: '人间有味',
    titleEn: 'Flavors of Life',
    category: 'jilupian',
    year: 2024,
    rating: 9.2,
    director: '陈晓卿',
    actors: [],
    duration: '95分钟',
    description: '一部关于中国各地街头美食的纪录电影。从成都的火锅到广州的早茶，从西安的肉夹馍到上海的蟹粉小笼，影片以温暖的镜头捕捉了食物背后的人情故事，展现了中国饮食文化的多样性与深厚底蕴。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20warm%20Chinese%20documentary%20movie%20poster%20featuring%20various%20Chinese%20street%20food%20arranged%20artistically%2C%20steaming%20dumplings%20and%20noodles%2C%20rich%20amber%20and%20golden%20tones%2C%20Chinese%20food%20documentary%20film%20poster%20design%2C%20appetizing%20presentation%2C%20cultural%20warmth%2C%20clean%20composition&width=600&height=850&seq=mitao-poster-008&orientation=portrait',
    featured: true,
    releaseDate: '2024-11-22',
  },
  {
    id: 'movie-009',
    title: '恋恋笔记本',
    titleEn: 'Love Notes',
    category: 'aiqing',
    year: 2025,
    rating: 8.3,
    director: '曾国祥',
    actors: ['易烊千玺', '刘浩存', '任敏'],
    duration: '112分钟',
    description: '大学时代的青涩暗恋，多年后的意外重逢。一本写满心事的笔记本，记录了两个年轻人跨越十年的情感历程。影片用诗意的画面和细腻的情感刻画，让观众重温了青春时代最纯真的心动。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20tender%20Chinese%20romance%20movie%20poster%20showing%20a%20notebook%20and%20two%20young%20people%20on%20a%20university%20campus%2C%20warm%20sunset%20golden%20light%2C%20nostalgic%20atmosphere%2C%20Chinese%20romantic%20film%20poster%20design%2C%20delicate%20handwritten%20notes%2C%20autumn%20leaves%2C%20soft%20bokeh&width=600&height=850&seq=mitao-poster-009&orientation=portrait',
    featured: false,
    releaseDate: '2025-02-14',
  },
  {
    id: 'movie-010',
    title: '功夫厨神',
    titleEn: 'Kung Fu Kitchen',
    category: 'xiju',
    year: 2024,
    rating: 7.9,
    director: '周星驰',
    actors: ['黄渤', '王宝强', '徐峥'],
    duration: '108分钟',
    description: '一个热爱烹饪的功夫高手，为了拯救濒临倒闭的百年老店，在厨艺大赛上大展身手。将中国功夫与烹饪技艺完美融合，不仅烹制出令人垂涎的美味佳肴，更打出了一场笑料百出的欢乐盛宴。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20comedy%20movie%20poster%20with%20a%20chef%20doing%20martial%20arts%20pose%20in%20a%20steamy%20kitchen%2C%20wok%20flames%20and%20flying%20vegetables%2C%20warm%20red%20and%20golden%20tones%2C%20Chinese%20comedy%20film%20poster%20design%2C%20energetic%20composition%2C%20playful%20vibe&width=600&height=850&seq=mitao-poster-010&orientation=portrait',
    featured: false,
    releaseDate: '2024-06-15',
  },
  {
    id: 'movie-011',
    title: '悬崖之上',
    titleEn: 'Above the Cliff',
    category: 'dongzuo',
    year: 2025,
    rating: 8.6,
    director: '张艺谋',
    actors: ['张涵予', '于和伟', '秦海璐'],
    duration: '135分钟',
    description: '抗日战争时期，一支精英特工小队深入敌后执行秘密任务。在白雪皑皑的东北密林中，他们与敌人展开了一场智慧与勇气的生死较量。极致的画面美感与紧张的剧情张力，成就了一部震撼人心的谍战动作大片。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20Chinese%20action%20spy%20movie%20poster%20set%20in%20snowy%20forest%2C%20dark%20figures%20in%20long%20coats%2C%20dramatic%20contrast%20between%20white%20snow%20and%20dark%20silhouettes%2C%20Chinese%20action%20film%20poster%20design%2C%20minimalist%20elegant%20composition%2C%20wintry%20atmosphere&width=600&height=850&seq=mitao-poster-011&orientation=portrait',
    featured: true,
    releaseDate: '2025-01-29',
  },
  {
    id: 'movie-012',
    title: '深海回响',
    titleEn: 'Echoes from the Deep',
    category: 'kehuan',
    year: 2025,
    rating: 8.1,
    director: '路阳',
    actors: ['邓超', '辛芷蕾', '李现'],
    duration: '140分钟',
    description: '深海探测队在太平洋底发现了一座神秘的水下遗迹，遗迹中隐藏着来自远古文明的讯息。当科学家们试图解码这些讯息时，一场改变人类命运的冒险随之展开。震撼的水下视效与宏大的世界观设定令人叹为观止。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20sci-fi%20movie%20poster%20showing%20an%20underwater%20ancient%20ruin%20with%20glowing%20blue%20light%2C%20deep%20ocean%20atmosphere%2C%20divers%20approaching%2C%20warm%20light%20beams%20from%20above%2C%20Chinese%20science%20fiction%20film%20poster%20design%2C%20grand%20scale%2C%20mysterious%20aura&width=600&height=850&seq=mitao-poster-012&orientation=portrait',
    featured: false,
    releaseDate: '2025-08-22',
  },
];